import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgMagnifier(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.5 3.75C8.56294 3.75 3.75 8.56294 3.75 14.5C3.75 20.4371 8.56294 25.25 14.5 25.25C17.0181 25.25 19.334 24.3842 21.1663 22.934L26.9999 28.7677L28.7677 27L22.934 21.1662C24.3842 19.334 25.25 17.0181 25.25 14.5C25.25 8.56294 20.4371 3.75 14.5 3.75ZM6.25 14.5C6.25 9.94365 9.94365 6.25 14.5 6.25C19.0563 6.25 22.75 9.94365 22.75 14.5C22.75 19.0563 19.0563 22.75 14.5 22.75C9.94365 22.75 6.25 19.0563 6.25 14.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMagnifier);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
